export default {
	message: "Seu Zé não achou nada aqui...",
	goHome: "Voltar ao início",
};
